import React from 'react';
import { useEnvironment, useBi } from '@wix/yoshi-flow-editor';

import { groupsHeaderButtonClick } from '@wix/bi-logger-groups-data/v2';

import { Box } from 'wui/Box';
import { Typography } from 'wui/Typography';
import { Show } from 'wui/Show';

import { CreateEventButton } from '../CreateEventButton';

type EventListHeaderProps = {
  groupId: string;
  withCreateButton: boolean;
  label: string;
};

export function EventListHeader({
  label,
  withCreateButton,
  groupId,
}: EventListHeaderProps) {
  const { isMobile } = useEnvironment();
  const bi = useBi();

  return (
    <Box
      align="space-between"
      padding={isMobile ? '0 SP5 SP6 SP5' : 'SP5 0 SP8 0'}
      data-hook="event-list-header"
    >
      <Typography as="h2" variant="h2-32">
        {label}
      </Typography>
      <Show if={withCreateButton}>
        <CreateEventButton
          groupId={groupId}
          onClick={reportHeaderCreateEventClick}
        />
      </Show>
    </Box>
  );

  function reportHeaderCreateEventClick() {
    bi.report(
      groupsHeaderButtonClick({
        button_name: 'create_event',
        page_name: 'events_livesite',
        group_id: groupId,
      }),
    );
  }
}

EventListHeader.displayName = 'EventListHeader';
